import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({providedIn: 'root'})
export class GuardLogOutService implements CanActivate {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate() {
    if (this.authenticationService.isUserLoggedIn()) {
      this.router.navigate(['/profile/edit']);
      return false;
    }
    return true;
  }
}
